import React from "react";
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import Dialog from './ActionDialog';
import HtmlContent from "./HtmlContent";
import { useTranslation } from 'react-i18next';

const WarningDialog = ({ open, onHide, onClose, title, warningText, fullWidth }) => {
    const { t } = useTranslation();
    return (
        <Dialog fullWidth={fullWidth} open={open} onClose={onHide}>
            <DialogTitle>
                <Typography variant="h6" component={"span"} color="error" >
                    <HtmlContent content={title} />
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" color="textSecondary">
                    <HtmlContent content={warningText} />
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button className="app-btn" onClick={onClose} color="secondary" variant="contained">
                    {t('common.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningDialog;
